import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function getInitial() {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    try {
        return window.matchMedia(QUERY).matches;
    } catch {
        return false;
    }
}

/**
 * useReducedMotion
 * Tracks the user's `prefers-reduced-motion` setting so purely decorative
 * animation (artwork crossfades, shimmer) can be disabled.
 */
export function useReducedMotion() {
    const [reduced, setReduced] = useState(getInitial);

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
        let mql;
        try {
            mql = window.matchMedia(QUERY);
        } catch {
            return undefined;
        }
        const onChange = (event) => setReduced(!!event.matches);
        setReduced(!!mql.matches);
        if (typeof mql.addEventListener === 'function') {
            mql.addEventListener('change', onChange);
            return () => mql.removeEventListener('change', onChange);
        }
        if (typeof mql.addListener === 'function') {
            mql.addListener(onChange);
            return () => mql.removeListener(onChange);
        }
        return undefined;
    }, []);

    return reduced;
}
